import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vShow as _vShow, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c9843fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search_container" }
const _hoisted_2 = { class: "checkbox_container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "企画中止を含む", -1))
const _hoisted_4 = { class: "paging_container" }
const _hoisted_5 = { class: "Daiwari_TableContainer" }
const _hoisted_6 = { class: "Daiwari_Table" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "Daiwari_Table_minimum" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "Daiwari_Table_middle" }, "ステータス", -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "Btn_Container" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "text_left" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_16 = {
  class: "Btn_Container text_left",
  style: {"justify-content":"flex-start"}
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_21 = {
  key: 0,
  class: "ResultMessageNull"
}

import { ref } from "vue";
import PankuzuHeader from "@/components/PankuzuHeader.vue";
import SearchSimple from "@/components/search/SearchSimple.vue";
import axios from "axios";
import { useStore } from "vuex";
import Paginate from "vuejs-paginate-next";
import { useRouter } from "vue-router";

//propsの定義
type SearchResult = typeof search_result.value[0];

export default /*#__PURE__*/_defineComponent({
  __name: 'Daiwari',
  props: {
  isActive_SidebarFlg: { type: Boolean },
},
  setup(__props) {

const props = __props;

const store = useStore();
const router = useRouter();

//ぱんくずヘッダー
const currentPathList = [
  { name: "台割一覧" },
];
//簡易検索
let isActive_KaniFlg = ref(false);
//詳細検索
let isActive_SyosaiFlg = ref(true);

// 全体で使用する変数--------------------------------------------
// ソート関連
let sortInfo = ref({
  sortItem: "",
  isKoujun: false,
});
let isSorting = ref(false);

// ページネーション関連処理-----------------------------------------
// 取得データ合計
let numberOfTotalData = ref<number>(0);
// 1ページあたりの表示データ数(一旦固定)
let dataPerPage = 100;
//表示中のページ範囲
let firstCount = ref<number>(0);
let finalCount = ref<number>(0);
// 総ページ数
const numberOfTotalPage = ref<number>(0);
// 現在のページ数
const currentPage = ref<number>(store.getters["search/getPageNumber"]);
const getTotalPage = () => {
  numberOfTotalPage.value = Math.ceil(numberOfTotalData.value / dataPerPage);
};
const onClickPage = (newPage: number) => {
  currentPage.value = newPage;
  store.commit("search/setPageNumber", currentPage.value);
  getDaiwariList();
};

// 台割一覧取得----------------------------------------------------
const search_result = ref([
  {
    daiwariId: 1,
    kikakuId: 1,
    title: "20240301-2",
    hangata: null,
    isChild: null,
    isKakutei: null,
    oyaDaiwariId: null,
    daiwariEdabanName: null,
    createdBy: "秋田書店テストユーザー",
    createdAt: "2024-03-01-04-54-48",
    updatedBy: null,
    updatedAt: null,
    hannyuKiboYearAndMonth: "2024-03",
    version: null,
    daiwariData: null,
    kanrenDaiwariList: null,
    isCancel: false,
    daiwariEdabanList: [
      {
        daiwariEdabanId: null,
        oyaDaiwariId: null,
        daiwariId: 2,
        daiwariEdabanName: "企画ID 10 台割ID 1 台割枝番作成テスト1",
        isDensi: null,
        tojiId: null,
        toji: null,
        createdBy: null,
        createdAt: null,
        updatedBy: null,
        updatedAt: null,
      },
    ],
  },
]);
const containsCancel = ref(false);
const getDaiwariList = async () => {
  try {
    const freeword = store.getters["search/getSearchSimpleState"];
    let url = "";
    // ソート時のデータ取得URL
    if (isSorting.value === true) {
      url = `${store.getters["getBaseUrl"]}/daiwari/list?freeword=${freeword}&containsCancel=${containsCancel.value}&order=${sortInfo.value.sortItem}&sort=${sortInfo.value.isKoujun}&page=${currentPage.value}&numberOfDisplay=${dataPerPage}`;
    }
    // 通常のデータ取得URL
    else {
      url = `${store.getters["getBaseUrl"]}/daiwari/list?freeword=${freeword}&containsCancel=${containsCancel.value}&page=${currentPage.value}&numberOfDisplay=${dataPerPage}`;
    }
    const res = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    });
    search_result.value = res.data.display as SearchResult[];

    // 【仮】仮データ格納
    // search_result.value = [
    //   {
    //     daiwariId: 8,
    //     kikakuId: null,
    //     title: "20240301-4",
    //     hangata: null,
    //     isChild: null,
    //     isKakutei: null,
    //     oyaDaiwariId: null,
    //     daiwariEdabanName: null,
    //     createdBy: "秋田書店テストユーザー",
    //     createdAt: "2024-03-01-08-22-49",
    //     updatedBy: null,
    //     updatedAt: null,
    //     hannyuKiboYearAndMonth: "2024-03",
    //     version: null,
    //     daiwariData: null,
    //     kanrenDaiwariList: null,
    //     isCancel: null,
    //     daiwariEdabanList: [],
    //   },
    //   {
    //     daiwariId: 1,
    //     kikakuId: null,
    //     title: "20240301-2",
    //     hangata: null,
    //     isChild: null,
    //     isKakutei: null,
    //     oyaDaiwariId: null,
    //     daiwariEdabanName: null,
    //     createdBy: "秋田書店テストユーザー",
    //     createdAt: "2024-03-01-04-54-48",
    //     updatedBy: null,
    //     updatedAt: null,
    //     hannyuKiboYearAndMonth: "2024-03",
    //     version: null,
    //     daiwariData: null,
    //     kanrenDaiwariList: null,
    //     isCancel: false,
    //     daiwariEdabanList: [
    //       {
    //         daiwariEdabanId: null,
    //         oyaDaiwariId: null,
    //         daiwariId: 2,
    //         daiwariEdabanName: "企画ID 10 台割ID 1 台割枝番作成テスト1",
    //         isDensi: null,
    //         tojiId: null,
    //         toji: null,
    //         createdBy: null,
    //         createdAt: null,
    //         updatedBy: null,
    //         updatedAt: null,
    //       },
    //       {
    //         daiwariEdabanId: null,
    //         oyaDaiwariId: null,
    //         daiwariId: 3,
    //         daiwariEdabanName: "企画ID 10 台割ID 1 台割枝番作成テスト2",
    //         isDensi: null,
    //         tojiId: null,
    //         toji: null,
    //         createdBy: null,
    //         createdAt: null,
    //         updatedBy: null,
    //         updatedAt: null,
    //       },
    //       {
    //         daiwariEdabanId: null,
    //         oyaDaiwariId: null,
    //         daiwariId: 4,
    //         daiwariEdabanName: "企画ID 10 台割ID 1 台割枝番作成テスト3",
    //         isDensi: null,
    //         tojiId: null,
    //         toji: null,
    //         createdBy: null,
    //         createdAt: null,
    //         updatedBy: null,
    //         updatedAt: null,
    //       },
    //     ],
    //   },
    //   {
    //     daiwariId: 9,
    //     kikakuId: null,
    //     title: "20240301-2",
    //     hangata: null,
    //     isChild: null,
    //     isKakutei: null,
    //     oyaDaiwariId: null,
    //     daiwariEdabanName: null,
    //     createdBy: "秋田書店テストユーザー",
    //     createdAt: "2024-03-01-04-54-48",
    //     updatedBy: null,
    //     updatedAt: null,
    //     hannyuKiboYearAndMonth: "2024-03",
    //     version: null,
    //     daiwariData: null,
    //     kanrenDaiwariList: null,
    //     isCancel: true,
    //     daiwariEdabanList: [
    //       {
    //         daiwariEdabanId: null,
    //         oyaDaiwariId: null,
    //         daiwariId: 10,
    //         daiwariEdabanName: "企画ID 10 台割ID 1 台割枝番作成テスト1",
    //         isDensi: null,
    //         tojiId: null,
    //         toji: null,
    //         createdBy: null,
    //         createdAt: null,
    //         updatedBy: null,
    //         updatedAt: null,
    //       },
    //       {
    //         daiwariEdabanId: null,
    //         oyaDaiwariId: null,
    //         daiwariId: 11,
    //         daiwariEdabanName: "企画ID 10 台割ID 1 台割枝番作成テスト2",
    //         isDensi: null,
    //         tojiId: null,
    //         toji: null,
    //         createdBy: null,
    //         createdAt: null,
    //         updatedBy: null,
    //         updatedAt: null,
    //       },
    //       {
    //         daiwariEdabanId: null,
    //         oyaDaiwariId: null,
    //         daiwariId: 12,
    //         daiwariEdabanName: "企画ID 10 台割ID 1 台割枝番作成テスト3",
    //         isDensi: null,
    //         tojiId: null,
    //         toji: null,
    //         createdBy: null,
    //         createdAt: null,
    //         updatedBy: null,
    //         updatedAt: null,
    //       },
    //     ],
    //   },
    //   {
    //     daiwariId: 13,
    //     kikakuId: null,
    //     title: "20240301-4",
    //     hangata: null,
    //     isChild: null,
    //     isKakutei: null,
    //     oyaDaiwariId: null,
    //     daiwariEdabanName: null,
    //     createdBy: "秋田書店テストユーザー",
    //     createdAt: "2024-03-01-08-22-49",
    //     updatedBy: null,
    //     updatedAt: null,
    //     hannyuKiboYearAndMonth: "2024-03",
    //     version: null,
    //     daiwariData: null,
    //     kanrenDaiwariList: null,
    //     isCancel: null,
    //     daiwariEdabanList: [],
    //   },
    // ];

    // 枝番表示制御配列にデータを格納
    edabanVisibleList.value.splice(0);
    search_result.value.forEach((result) => {
      if (result.daiwariEdabanList.length > 0) {
        edabanVisibleList.value.push({
          parentDaiwariId: result.daiwariId,
          isVisible: false,
        });
      }
    });

    numberOfTotalData.value = res.data.size;
    firstCount.value = res.data.firstCount;
    finalCount.value = res.data.finalCount;
    getTotalPage();
  } catch (error) {
    console.log(error);
    alert("台割一覧の取得に失敗しました");
  }
};
getDaiwariList();

const onSearch = () => {
  store.commit("search/resetPage");
  currentPage.value = 1;
  isSorting.value = false;
  getDaiwariList();
};

// 枝番台割表示制御-----------------------------------------------------
const edabanVisibleList = ref([
  {
    parentDaiwariId: -1,
    isVisible: false,
  },
]);
const toggleEdaban = (daiwariId: number) => {
  edabanVisibleList.value.forEach((edaban) => {
    if (edaban.parentDaiwariId === daiwariId) {
      edaban.isVisible = !edaban.isVisible;
    }
  });
};
const isVisibleEdaban = (daiwariId: number) => {
  let isVisible = false;
  edabanVisibleList.value.forEach((edaban) => {
    if (edaban.parentDaiwariId === daiwariId) {
      isVisible = edaban.isVisible;
    }
  });
  return isVisible;
};

// ステータス制御
const statusName = (daiwari: SearchResult) => {
  let statusInfo = {
    name: "",
    color: "",
  };
  if (daiwari.isCancel === true) {
    statusInfo = {
      name: "企画中止",
      color: "#fbb0b7",
    };
  }
  return statusInfo;
};

// テーブルソート処理--------------------------------------------------------------------------------------
const sortTable = async (sortItem: string) => {
  isSorting.value = true;
  if (sortInfo.value.sortItem === sortItem) {
    sortInfo.value.isKoujun = !sortInfo.value.isKoujun;
  } else {
    sortInfo.value.isKoujun = false;
    // 別のソートに切り替えた時ページネーションを1にする
    currentPage.value = 1;
    store.commit("search/setPageNumber", currentPage.value);
  }
  sortInfo.value.sortItem = sortItem;
  getDaiwariList();
};

const showSortSymbol = (sortItem: string) => {
  if (
    isSorting.value &&
    sortInfo.value.sortItem === sortItem &&
    sortInfo.value.isKoujun
  ) {
    return "▼";
  } else if (
    isSorting.value &&
    sortInfo.value.sortItem === sortItem &&
    !sortInfo.value.isKoujun
  ) {
    return "▲";
  } else {
    return "";
  }
};

// 画面遷移-------------------------------------------------------------
const clickRouterBtn = (
  daiwariId: number,
  kikakuId: number,
  isEdaban: boolean,
  isYomitori: boolean
) => {
  router.push({
    path: "/daiwari_edit",
    query: {
      daiwariId: daiwariId,
      kikakuId: 1, // 仮
      isEdaban: String(isEdaban),
      isYomitori: String(isYomitori),
    },
  });
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["Daiwari", {
      Show_KaniSearch: _unref(isActive_KaniFlg),
      Show_SyosaiSearch: _unref(isActive_SyosaiFlg),
      SideBar_False: !props.isActive_SidebarFlg,
      SideBar_True: props.isActive_SidebarFlg,
    }])
  }, [
    _createVNode(PankuzuHeader, {
      isActive_SidebarFlg: props.isActive_SidebarFlg,
      currentPathList: currentPathList
    }, null, 8, ["isActive_SidebarFlg"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(SearchSimple, {
        placeholder: '台割のキーワードを入力',
        onOnSearch: onSearch,
        ref: "searchSimple"
      }, null, 512),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((containsCancel).value = $event))
        }, null, 512), [
          [_vModelCheckbox, containsCancel.value]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(Paginate), {
        "page-count": numberOfTotalPage.value,
        "hide-prev-next": true,
        "page-range": 3,
        "prev-text": '<',
        "next-text": '>',
        "container-class": 'pagination',
        "page-class": 'page-item',
        "page-link-class": 'page-item--link',
        "active-class": 'page-item--active',
        "click-handler": onClickPage,
        "force-page": currentPage.value
      }, null, 8, ["page-count", "force-page"]),
      _withDirectives(_createElementVNode("span", { class: "paging_result" }, " 検索結果：" + _toDisplayString(_unref(numberOfTotalData)) + "件/" + _toDisplayString(_unref(firstCount)) + "～" + _toDisplayString(_unref(finalCount)) + "件を表示", 513), [
        [_vShow, search_result.value.length]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("table", _hoisted_6, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _hoisted_7,
            _createElementVNode("th", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (sortTable('daiwariId'))),
              class: "Daiwari_Table_middle th_sort"
            }, [
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("daiwariId")), 1),
              _createTextVNode(" 台割ID ")
            ]),
            _createElementVNode("th", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (sortTable('title'))),
              class: "th_sort"
            }, [
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("title")), 1),
              _createTextVNode(" タイトル ")
            ]),
            _hoisted_8
          ])
        ]),
        (search_result.value.length)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(search_result.value, (item, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  _createElementVNode("tr", {
                    class: _normalizeClass({ bg_gray: (index + 1) % 2 === 0 })
                  }, [
                    _createElementVNode("td", null, [
                      (
                    item.daiwariEdabanList.length > 0 &&
                    !isVisibleEdaban(item.daiwariId)
                  )
                        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                            key: 0,
                            onClick: ($event: any) => (toggleEdaban(item.daiwariId)),
                            class: "Daiwari_Table_Icon icon_caret",
                            icon: "caret-right"
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (
                    item.daiwariEdabanList.length > 0 &&
                    isVisibleEdaban(item.daiwariId)
                  )
                        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                            key: 1,
                            onClick: ($event: any) => (toggleEdaban(item.daiwariId)),
                            class: "Daiwari_Table_Icon icon_caret",
                            icon: "caret-down"
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_10, [
                      (item.isCancel === true)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: ($event: any) => (
                      clickRouterBtn(
                        item.daiwariId,
                        item.kikakuId,
                        false,
                        false
                      )
                    ),
                            class: "Daiwari_Table_Button btn_gray"
                          }, " 参照 ", 8, _hoisted_11))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => (
                      clickRouterBtn(item.daiwariId, item.kikakuId, false, true)
                    ),
                              class: "Daiwari_Table_Button btn_orange"
                            }, " 読取 ", 8, _hoisted_12),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (
                      clickRouterBtn(
                        item.daiwariId,
                        item.kikakuId,
                        false,
                        false
                      )
                    ),
                              class: "Daiwari_Table_Button btn_green"
                            }, [
                              _createVNode(_component_font_awesome_icon, {
                                class: "Daiwari_Table_Icon",
                                icon: "pen",
                                style: {"margin-right":"5px"}
                              }),
                              _createTextVNode("編集 ")
                            ], 8, _hoisted_13)
                          ], 64)),
                      _createTextVNode(" " + _toDisplayString(item.daiwariId), 1)
                    ]),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(item.title), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", {
                        class: "badge",
                        style: _normalizeStyle({ background: statusName(item).color })
                      }, _toDisplayString(statusName(item).name), 5)
                    ])
                  ], 2),
                  (
                item.daiwariEdabanList.length > 0 &&
                isVisibleEdaban(item.daiwariId)
              )
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.daiwariEdabanList, (edabanItem) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: edabanItem.daiwariId,
                          class: _normalizeClass(["edaban_tr", { bg_gray: (index + 1) % 2 === 0 }])
                        }, [
                          _createElementVNode("td", null, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: ['fas', 'level-up-alt'],
                              style: {"transform":"rotate(90deg)"}
                            })
                          ]),
                          _hoisted_15,
                          _createElementVNode("td", _hoisted_16, [
                            (item.isCancel === true)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  onClick: ($event: any) => (
                        clickRouterBtn(
                          edabanItem.daiwariId,
                          item.kikakuId,
                          true,
                          false
                        )
                      ),
                                  class: "Daiwari_Table_Button btn_gray"
                                }, " 参照 ", 8, _hoisted_17))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (
                        clickRouterBtn(
                          edabanItem.daiwariId,
                          item.kikakuId,
                          true,
                          true
                        )
                      ),
                                    class: "Daiwari_Table_Button btn_orange"
                                  }, " 読取 ", 8, _hoisted_18),
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (
                        clickRouterBtn(
                          edabanItem.daiwariId,
                          item.kikakuId,
                          true,
                          false
                        )
                      ),
                                    class: "Daiwari_Table_Button btn_green"
                                  }, [
                                    _createVNode(_component_font_awesome_icon, {
                                      class: "Daiwari_Table_Icon",
                                      icon: "pen",
                                      style: {"margin-right":"5px"}
                                    }),
                                    _createTextVNode("編集 ")
                                  ], 8, _hoisted_19)
                                ], 64)),
                            _createTextVNode(" " + _toDisplayString(edabanItem.daiwariEdabanName), 1)
                          ]),
                          _hoisted_20
                        ], 2))
                      }), 128))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      (!search_result.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, " ※検索結果はありません "))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})